import React from 'react';
import PropTypes from 'prop-types';
import { Body, CardContainer, Date } from './style';
import HtmlRaw from '../../HtmlRaw';
//import MultiActions from '../../MultiActions';
import { timestampToDate } from '../../../../utils/common';
import Text from '../../Text';

const CardEventsSmall = ({ data, onClick, onClickLeave }) => {
  return (
    <CardContainer>
      <Date>
        <p className="day">{timestampToDate(data?.activity_date, 'DD')}</p>
        <p className="month">{timestampToDate(data?.activity_date, 'MMM')}</p>
      </Date>
      <Body>
        <Text type="h3" className="line-clamp two-lines" onClick={onClick}>
          {data?.event_title}
        </Text>
        <HtmlRaw html={data?.title} className="ellipsis" />
      </Body>
      {/*
      <MultiActions
        actions={[
          {
            label: 'Riprendi',
            icon: 'arrow-circle-right',
            onClick,
          },
          {
            label: 'Abbandona',
            icon: 'x-circle',
            onClick: onClickLeave,
          },
        ]}
      />
      */}
    </CardContainer>
  );
};

CardEventsSmall.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  onClickLeave: PropTypes.func,
};

export default CardEventsSmall;
